import React, { useState, useEffect, useRef } from "react";
import VideoComponent from "../../VideoComponent";
import HeaderMenu from "../../Header/header-menu";
import Header from "../../Header/header";
import './Inbrija-stories.css'
import Footer from "../../Footer/Footer";
import Isi from "../../ISI/Isi";
import IsiFrame from "../../ISI/Isi-frame";
import NavigationBar from "../../NavigationBar/NavigationBar";
import Modal from '../Modal';
import { useLocation, useNavigate, Link } from "react-router-dom";
import MainLayout from "../../Layouts/Main_Layout";
import { Helmet } from "react-helmet";

export default function InbrijaStories() {
    const [showJimmy, setShowJimmy] = useState(false);
    const [showRachel, setShowRachel] = useState(false);
    const [showBern, setShowBern] = useState(false);
    const [showStephanie, setShowStephanie] = useState(false);
    const [showJohn, setShowJohn] = useState(false);
    const [showBob, setShowBob] = useState(false);
    const [showKay, setShowKay] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const inbrijastories = useRef(null)
    const myRef = useRef(null)
    const [show, setShow] = useState(true)
    const executeScroll = () => {
        myRef.current.scrollIntoView();
        setShow(true)
    }
    const handleVideoClick = (clickClass) => {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag('event', 'patient_video', {
                // 'event_category': 'video_play',
                'event_category': 'video_start',
                'event_label': clickClass,
                'page_location': window.location.href
            });
        }
    }

    const closeModal = () => {
        navigate.goBack(); // Remove #myModal from the URL
    };


    useEffect(() => {

        if (location.hash === '#watch-rachel-patient-video') {
            setShowRachel(true);
        }
        if (location.hash === '#watch-stephanie-patient-video') {
            setShowStephanie(true)
        }
        if (location.hash === '#watch-jimmy-patient-video') {
            setShowJimmy(true)
        }
        if (location.hash === '#watch-carepartner-video') {
            setShowBern(true)
        }
        if (location.hash === '#watch-john-patient-video') {
            setShowJohn(true)
        }
        if (location.hash === '#watch-bob-patient-video') {
            setShowBob(true)
        }
        if (location.hash === '#watch-kay-patient-video') {
            setShowKay(true)
        }

        const calculateOffset = () => {
            const componentElement = myRef.current;

            if (myRef) {
                const offsetTop = componentElement.offsetTop;
                function handleScroll() {
                    if (window.innerHeight + window.scrollY > offsetTop) {
                        setShow(false);
                    }
                    else (
                        setShow(true)
                    )
                }
                window.addEventListener("scroll", handleScroll);
                return () => {
                    window.removeEventListener("scroll", handleScroll);
                };
            }
        };
        calculateOffset();
        window.addEventListener('resize', calculateOffset);
        return () => {
            window.removeEventListener('resize', calculateOffset);
        };
    }, [location, show]);

    const newPath = window.location.pathname;

    return (
        <MainLayout>
            <div className="inbrija-stories-page" ref={inbrijastories}>
                <Helmet>
                    <title>Real INBRIJA® Stories | INBRIJA® (levodopa inhalation powder)</title>
                    <meta property='og:title' content="Real INBRIJA® Stories | INBRIJA® (levodopa inhalation powder)" />
                    <meta name='description' content={`Meet the fighters. Watch real people discuss what they did when thier Parkinson's symptoms returned.`} />
                    <meta property='og:description' content={`Watch real people discuss what they did when their Parkinson's symptoms came back. See Indication, Important Safety Information, and Patient Information Leaflet.`} />
                    <meta property='og:site_name' content='INBRIJA.COM' />
                    <meta property='og:type' content='website' />
                    <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
                    <meta property='og:image:alt' content='INBRIJA logo' />
                </Helmet>
                <Header />
                <HeaderMenu>
                    <div className="container">
                        <div className="inbrija-stories-header">
                            <h1>Meet the <span>fighters</span></h1>
                            <h6 className="show_desktop">Real people fighting their returning Parkinson's symptoms</h6>
                            <h6 className="show_mobile">Real people fighting their returning Parkinson's symptoms</h6>
                        </div>
                    </div>
                </HeaderMenu>
                <div className="brush-style">
                </div>
                <div className="inbrija-stories-container">
                    <div className="container">
                        <div className="stories-heading">
                            Step into the lives of carepartners and real people with PD who are fighting to get back to their moments with INBRIJA
                        </div>
                        <div className="videos-container">
                            <VideoComponent hash={location.hash} patientId="play-jimmy-video" patientImage="/assets/website_images/jimmy-video.webp" patientName="Jimmy's Story" alt={`A man wearing a blue shirt sits and faces the camera. Text on the bottom right of the image reads "Jimmy's Story"`} onClick={() => { setShowJimmy(true); handleVideoClick('IS_watch_jimmy'); }} className="w-100" />
                            <VideoComponent patientId="play-rachel-video" patientImage="/assets/website_images/rachel-video.webp" patientName="Rachel's Story" alt={`Headshot of a woman looking off-camera. Text on the bottom right of image reads "Rachel's Story"`} onClick={() => { setShowRachel(true); handleVideoClick('IS_watch_rachel') }} />
                            <VideoComponent patientId="play-carepartner-video" hash={location.hash} patientImage="/assets/website_images/Carepartner-video.webp" patientName="Bernadette and Kristi's CarePartner Story" alt={`Two women sit at a table and smile at each other, mid conversation. Text on the bottom right reads "Bernadette and Kristi's CarePartner Story"`} onClick={() => { setShowBern(true); handleVideoClick('IS_watch_carepartner') }} />
                            <VideoComponent patientId="play-john-video" hash={location.hash} patientImage="/assets/website_images/john-video.webp" patientName="John's Story" alt={`A man with a golf club stands in his front lawn, readying his swing. Text on the bottom right reads "John's Story"`} onClick={() => { setShowJohn(true); handleVideoClick('IS_watch_john') }} />
                        </div>
                        <figcaption className="patient-stories-figcaption">Actual Patients. Individual Results may vary<br /><br /></figcaption>
                    </div>
                    <div className="talking-with-doctor center">
                        <div className="container">
                            <div className="talking-dr">
                                <div style={{ backgroundImage: `url("/assets/images/rescue-bg.webp")` }} className="talking-dr-background">
                                    <h1>Talking to your doctor about INBRIJA</h1>
                                </div>
                                <div className="talkin-dr-content">
                                    <div>
                                        <p>It helps to be organized when talking to your doctor. The Doctor Discussion Guide can help you organize your thoughts and questions for your next office visit.</p>
                                        <Link className="primary-button" to="/about-inbrija#talking-with-doctor" id="IS_talk_doctor">Talk With Your Doctor</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <NavigationBar
                    leftNavigation="Learn More About Our Savings Program"
                    rightNavigation="Review Common Questions and Answers"
                    leftNavigationid="IS_savings_program_footer"
                    rightNavigationid="IS_common_questions_footer"
                    leftNavigationLink="/savings-and-support"
                    rightNavigationLink="/common-questions"
                />
                <Modal show={showKay} muted={window.location.href === 'http://ec2-3-15-147-91.us-east-2.compute.amazonaws.com/patient-videos#watch-kay-patient-video' ? true : false} src="/videos/kay-video.mp4" title="kay's Story" handleClose={() => { setShowKay(false); navigate(window.location.pathname) }} videoTrack="/videos/kay-video.vtt" transcript="/videos/patient-videos-kay-transcript.html" />
                <Modal show={showJimmy} muted={window.location.href === 'http://ec2-3-15-147-91.us-east-2.compute.amazonaws.com/patient-videos#watch-jimmy-patient-video' ? true : false} src="/videos/patient-videos-jimmy.mp4" title="Jimmy's Story" handleClose={() => { setShowJimmy(false); navigate(window.location.pathname) }} videoTrack="/videos/patient-videos-jimmy.vtt" />
                <Modal show={showBern} muted={window.location.href === 'http://ec2-3-15-147-91.us-east-2.compute.amazonaws.com/patient-videos#watch-carepartner-video' ? true : false} src="/videos/patient-videos-carepartner-conversations.mp4" title="CarePartner Story" handleClose={() => { setShowBern(false); navigate(window.location.pathname); }} videoTrack="/videos/patient-videos-carepartner-conversations.vtt" transcript="/videos/patient-videos-carepartner-conversations-transcript.html" />
                <Modal show={showBob} muted={window.location.href === 'http://ec2-3-15-147-91.us-east-2.compute.amazonaws.com/patient-videos#watch-bob-patient-video' ? true : false} src="/videos/patient-videos-bob.mp4" title="Bob's Story" handleClose={() => { setShowBob(false); navigate(window.location.pathname); }} videoTrack="/videos/patient-video-bob.vtt" transcript="/videos/patient-videos-bob-transcript.html" />
                <Modal show={showJohn} muted={window.location.href === 'http://ec2-3-15-147-91.us-east-2.compute.amazonaws.com/patient-videos#watch-john-patient-video' ? true : false} src="/videos/patient-videos-john.mp4" title="John's Story" handleClose={() => { setShowJohn(false); navigate(window.location.pathname); }} videoTrack="/videos/patient-videos-john.vtt" />
                <Modal show={showRachel} muted={window.location.href === 'http://ec2-3-15-147-91.us-east-2.compute.amazonaws.com/patient-videos#watch-rachel-patient-video' ? true : false} src="/videos/patient-videos-rachel.mp4" title="Rachel's Story" handleClose={() => { setShowRachel(false); navigate(window.location.pathname); }} videoTrack="/videos/patient-videos-rachel.vtt" />
                <Modal show={showStephanie} muted={window.location.href === 'http://ec2-3-15-147-91.us-east-2.compute.amazonaws.com/patient-videos#watch-stephanie-patient-video' ? true : false} src="/videos/patient-videos-stephanie.mp4" title="Stephanie's Story" handleClose={() => { setShowStephanie(false); navigate(window.location.pathname); }} videoTrack="/videos/patient-videos-stephanie.vtt" transcript="/videos/patient-videos-stephanie-transcript.html" />
                <div ref={myRef}>
                    <Isi />
                </div>
                {show ?
                    <IsiFrame onClick={executeScroll} /> : ''}
                <Footer partNum="3/26 US-INB-2400111v2"
                    facebookLink="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2Fpatient-videos&title=Real%20INBRIJA%20stories&description=Learn%20about%20Real%20INBRIJA%20Stories"
                    twitterCode="https://twitter.com/intent/tweet?text=Real%20INBRIJA%20stories.%20Learn%20about%20Real%20INBRIJA%20Stories%20https://www.inbrija.com/patient-videos"
                    title="Real INBRIJA® Stories | INBRIJA® (levodopa inhalation powder)"
                />
            </div>
        </MainLayout>
    )
}